export default __webpack_public_path__ + "static/silver-dolphin-3e49c0f34a6dd903d58874700327f43d.jpg";